import { useEffect } from 'react';

// The browser tab's title, per page (Testing #25). Every page used to carry the
// one title public/index.html ships with, so ten open tabs — or the history
// list, or a bookmark — all read the same and a screen reader announced the same
// name on every route.
//
// DEFAULT_TITLE is that index.html title, word for word: it is what the site is
// called before React runs, and what a page with no name of its own goes back to.
export const SITE_NAME = 'interestng';
export const DEFAULT_TITLE = 'interestng — Find Your Perfect Loan';

// "Active Loans" → "Active Loans — interestng". The page first, so it is the
// part a narrow tab still shows.
export const pageTitle = (name) => (name ? `${name} — ${SITE_NAME}` : DEFAULT_TITLE);

// Names the tab while the calling page is on screen. Leaving restores the
// default, so a page that sets no title never inherits the last page's name.
export default function useDocumentTitle(name) {
  useEffect(() => {
    document.title = pageTitle(name);
    return () => { document.title = DEFAULT_TITLE; };
  }, [name]);
}
